import { localStorageKeys } from 'src/constants/localStorageKeys'
import { LocalStorageService } from '../../../libraries/localStorage'
import type {
  ListFilter as StorageFilter,
  ApprovalReportsFilter as UIFilter,
} from '../../../views/types/utils/ListFilter'

const localStorageService = new LocalStorageService<StorageFilter>()
/**
 * 現在のLocalStorage内の承認レポート関連データを取得する
 */
export const getStorageData = () => {
  const listFilter = localStorageService.getItem(localStorageKeys.listFilter)
  const approvalReportsData = listFilter?.approvalReports
  return {
    listFilter,
    approvalReportsData,
    filter: approvalReportsData?.filter,
    pagination: approvalReportsData?.pagination,
  }
}

/**
 * 絞り込み情報を更新してLocalStorageに保存する
 * @param filter フロントで扱う絞り込み条件
 */
export const saveFilter = (filter?: UIFilter) => {
  const { listFilter, approvalReportsData } = getStorageData()

  const updatedFilters = listFilter
    ? {
        ...listFilter,
        approvalReports: {
          ...approvalReportsData,
          filter,
        },
      }
    : {
        approvalReports: {
          pagination: approvalReportsData?.pagination,
          filter,
        },
      }

  localStorageService.setItem(localStorageKeys.listFilter, updatedFilters)
}

/**
 * ページネーション情報を更新してLocalStorageに保存する
 * @param limit 1ページあたりの表示件数
 * @param offset オフセット値（開始位置）
 */
export const savePagination = (limit: number, offset: number) => {
  const { listFilter, approvalReportsData } = getStorageData()

  const pagination = { limit, offset }
  const updatedFilters = listFilter
    ? {
        ...listFilter,
        approvalReports: {
          ...approvalReportsData,
          pagination,
        },
      }
    : {
        approvalReports: {
          filter: approvalReportsData?.filter,
          pagination,
        },
      }

  localStorageService.setItem(localStorageKeys.listFilter, updatedFilters)
}
